/**
 * @file 端数計算モジュール
 * @namespace ddv2.library
 */

/**
 * @module fraction
 */

export default {
  /**
   * 端数区分から算出
   * @param {Num} money 金額
   * @param {string} hasuKbn 端数区分 01:切捨,02:四捨五入,03:切上
   * @returns {Num} 算出結果
   * @example
   * const a = tax.calcTaxFromIncluded(someMoney, hasuKbn)
   */
  calcFraction: function (money, hasuKbn) {
    switch (hasuKbn) {
      case '01':
        return Math.floor(money)
      case '02':
        return Math.round(money)
      case '03':
        return Math.ceil(money)
      default:
        return null
    }
  }
}
